/*
 	* 公告一览组件
 	* 描述：包括查询（表单）、表格和分页
 	* 创建时间：2017-03-28
 	* 创建人：baixx
 	* 修改时间：2017-3-31
*/
<template>
	<div class="wrapper-content fadeInRight animated tabBox" id="notice-list">
	    <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<!--表单查询开始-->
	     	<div class="form-horizontal pt10px">
	     		<div class="form-group mb0px">
					<label class="col-sm-1 control-label">开始时间</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
						<datepicker v-model="queryParam.startSendDate" class="form-control" ref="startDate"></datepicker>
						<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					</div>
					<label class="col-sm-1 control-label">结束时间</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
						<datepicker v-model="queryParam.endSendDate" class="form-control" ref="endDate"></datepicker>
						<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					</div>
					<label class="col-sm-1 control-label">公告内容</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="queryParam.content" maxlength="20">
				  </div>
				</div>
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button v-if="permission.indexOf('noticeList_reset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
						<button v-if="permission.indexOf('noticeList_select') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
					</div>
				</div>
			</div>
			<!--表单查询结束-->
			<div class="hr-line-dashed"></div>
			<!--表格开始-->
			<table class="table mb0px table-striped table-bordered">
				<thead>
					<tr>
						<th v-for="(thead, index) in theadList" :key="'noticelist' + index">{{thead}}</th>
						<th></th>
					</tr>
				</thead>
				<transition-group name="list-complete" tag="tbody">
					<tr v-for="(fileInfo,index) in orgList" v-bind:key="index + 'noticelistFile'" class="list-complete-item">
						<td>{{index+1}}</td>
						<td>{{fileInfo.sendDate}}</td>
						<td>{{fileInfo.sourceName}}</td>
						<td>
							<font :color="fileInfo.statusName=='紧急'?'red':''">{{fileInfo.statusName}}</font>

						</td>
						<td>{{fileInfo.sendStateName}}</td>
						<td>{{fileInfo.title}}</td>
						<td>{{fileInfo.content}}</td>
							<td class="text-center">
								<a v-if="permission.indexOf('noticeList_detail') == -1" class="text-left" @click="openDetail(index)">详情</a>
							</td>
					</tr>
				</transition-group>
			</table>
			<!--分页组件开始-->
			<pagination v-if="orgList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
			<!--分页组件结束-->
			<!--弹框组件开始-->
			<sub-page :show="showSubPage" :bigTitleMsg="bigTitle" v-on:cancel="closeSubPage">
				<div slot="bodycontent">
					<page-notice-details :data="detailInfo" v-on:toClose="closeSubPage"></page-notice-details>
				</div>
			</sub-page>
			<!--弹框组件结束-->
		 	<!--弹出框子组件-->
			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
			        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
			    </div>
			</tab-modal>
		</div>
	</div>
</template>
<script>
	import Datepicker from 'components/common/datepicker/Datepicker'
import Pagination from 'components/common/Pagination'
import SubPage from 'components/common/SubPage'
import PageNoticeDetails from 'components/pages/notice/PageNoticeDetails'
import TabModal from 'components/common/TabModal'
import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
import classlist from 'util/classlist'
	export default {
	  name: 'PageNoticeList',
	  components: {
	    Pagination,
	    SubPage,
	    PageNoticeDetails,
	    TabModal,
	    Datepicker
	  },
	  data () {
	    return {
	      permission: this.$store.state.permission.permission['noticeList'] ? this.$store.state.permission.permission['noticeList'] : [],
	      loadingstatus: false,
	      detailInfo: {},					// 公告详情对象
	      messageStr: '',					// 弹出框内容
	      scrollTop: '',	                // 传给subPage的top值
	      bigTitle: '',	                // 传给subPage的标题
	      showSubPage: false,             // 默认不显示subpage
	      param: {}, 		                // 向后台传的参数
	      pageInfo: {},	                // 分页所需信息
	      orgList: [],                    // 表格数据列表
	      content: '',                    // 公告内容
	      theadList: ['序号', '发布时间', '发布来源', '重要度', '状态', '公告标题', '公告内容'],
			    queryParam: {											// 查询参数
	      content: '',
	      startSendDate: '',							        // 开始发布时间
	      endSendDate: '',                                    // 结束发布时间
	      in_col: 'title,content',		                    // 包含的列
	      page_index: 1                                      // 当前第几页
	    }
	    }
	  },
	  watch: {
	    'param' () {
	      this.getTableInfo()
	    }
	  },
	  beforeMount () {
	    this.getTableInfo()
	  },
	  computed: {
			//	起止时间是否合法
	    validDates: function () {
	      if (this.queryParam.startSendDate && this.queryParam.endSendDate && this.queryParam.startSendDate > this.queryParam.endSendDate) {
	        return false
	      } else {
	        return true
	      }
	    }
	  },
	  methods: {
			// 查询方法
	    searchInfo () {
	      this.queryParam.page_index = 1
	      this.getTableInfo()
	    },
			// 初始化信息
	    getTableInfo: function () {
	      this.loadingstatus = true
	      this.$http.get(process.env.API_ROOT + '/notice/ntcs', {params: this.queryParam})
				.then(res => {
	  if (res.body.success) {
	    const resInfo = res.body.data
	    const {pageNum, pages, total, isFirstPage, isLastPage} = resInfo
	    this.pageInfo = {
	      pageNum: pageNum,
	      pages: pages,
	      total: total,
	      isFirstPage: isFirstPage,
	      isLastPage: isLastPage
	    }
	    this.orgList = resInfo.list
	  } else {
	    this.openModalMsg(res.body.message)
	  }
	  this.loadingstatus = false
	}, res => {
	  this.openModalMsg(res.body.message)
	  this.loadingstatus = false
	}).catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	  this.loadingstatus = false
	})
	    },
			// 重置信息
	    resetQueryParams: function () {
	      this.$refs.startDate.handleClear()
	      this.$refs.endDate.handleClear()
	      this.queryParam = {
	        content: '',										// 公告内容
	        startSendDate: '',							        // 开始发布时间
	        endSendDate: '',                                    // 结束发布时间
	        in_col: 'title,content',		                    // 包含的列",		                                    // 包含的列
	        page_index: 1                                      // 当前第几页
	      }
	    },
		    // 从分页组件获取页码参数
	    getPageNo (param) {
	      this.queryParam.page_index = param
	      this.getTableInfo()
	    },
	    openDetail (index) {
	      if (this.orgList[index].sendState == 1) {
	        this.detailInfo = Object.assign({}, this.orgList[index])
	        this.showSubPage = true
	        this.bigTitle = '公告详情'
	        classlist.toggleScroll('close', '#notice-list', this)
	      }
	      if (this.orgList[index].sendState == 0) {
	        const obj = {
	          name: '公告下发',
	          code: 'noticeRelease',
	          id: 'PageNoticeRelease',
	          route: '/indexhome/noticeRelease',
	          No: 'noticeRelease'
	        }
	        this.$router.push(obj.route)
	        this.$store.dispatch('addTab', obj)
	      }
	    },
	    closeSubPage () {
	      this.showSubPage = false
	      classlist.toggleScroll('open', '#notice-list', this)
	    },
			// 消息弹出框相关
	    openModal (ref) {
            	this.$refs[ref].open()
            	classlist.toggleScroll('close', '#notice-list', this)
        	},
        	closeModal (ref) {
        		this.$refs[ref].close()
        		classlist.toggleScroll('open', '#notice-list', this)
        	},
        	closeModalMsg () {
        		this.closeModal('modalMsg')
        	},
        	openModalMsg (message) {
        		this.messageStr = message
        		this.openModal('modalMsg')
        	}
	  }
	}
</script>

<style scoped>
	#notice{
		position: relative;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// PageNoticeList.vue?0217507c